import {
  isNaN as _isNaN,
  sum as _sum,
  toNumber as _toNumber,
  random as _random,
  ceil as _ceil,
  isInteger as _isInteger,
  toInteger as _toInteger,
  floor as _floor,
  max as _max,
} from 'lodash-es'

export const sum = _sum
export const random = _random
export const isInteger = _isInteger
export const toInteger = _toInteger
export const floor = _floor
export const max = _max

export function formatted(value: number | string): string {
  if (!value && value !== 0) {
    return ''
  }

  try {
    const innerValue = toNumber(value)

    if (isNaN(innerValue)) {
      return `${value}`
    }

    const formattedValue: string = String(innerValue).replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      '$1,',
    )

    return formattedValue
  } catch (_error: any) {
    return ''
  }
}

export const toNumber = (value?: number | string): number => {
  return _toNumber(value)
}

export const isNaN = (value?: number): boolean => {
  return _isNaN(value)
}

export function replaceSpecialCharacter(value: string): string {
  return value.replace(REGEXP.NUMBER_AND_HYPHEN, '')
}

export function replaceComma(value: string) {
  return value.replace(REGEXP.NUMBER_COMMA_FORMAT, ',')
}

export function replaceLeaveOnlyOneHyphen(value: string) {
  const hypenIndex = value.indexOf('-')
  const detachHypen = value.replace(/-/gi, '')

  if (hypenIndex === 0 && value !== '-') {
    return `-${detachHypen}`
  }
  return detachHypen
}

export function ceil(n: number, precision?: number): number {
  return _ceil(n, precision)
}

export function formattedPhoneNumberWithHyphen(value: string) {
  const cleanedPhoneNumber = value.replace(/\D/g, '')
  return cleanedPhoneNumber.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3')
}

export function randomKey() {
  const now = Date.now()
  const current = Math.floor(now / 1000)
  const randomNumber = random(0, 9999999999)
  const key = `${current}_${randomNumber}`
  return key
}

export function parseIntInner(value: string | null): number {
  if (value === null) {
    return 0
  }
  const parseValue = parseInt(value)
  return isNaN(parseValue) ? 0 : parseValue
}
